<template>
  <div>
    <v-col cols="3">
      <v-btn
        block
        height="42px"
        color="#1db954"
        class="download-btn"
        @click="openModal('create')"
        style="color: black"
      >
        <v-icon>mdi mdi-plus-thick</v-icon>
        Neu
      </v-btn>
    </v-col>
    <v-data-table
      :key="mushroomUpdateKey"
      :headers="headers"
      :search="performSearch"
      :items="mushrooms"
      :loading="isLoading"
      :footer-props="{
        'items-per-page-text': 'Zeilen pro Seite',
      }"
    >
      <template v-slot:item.actions="{ item }">
        <div class="button-container">
          <v-icon
            small
            class="edit green--text icon-style"
            @click="openModal('update', item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="delete green--text icon-style"
            @click="openDeleteModal('delete', item)"
          >
            mdi-delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
    <create-mushroom-type
      :mushroom="{ abbreviation: '', germanName: '', latinName: '' }"
      :visible="dialogType === 'create'"
      :id="null"
      @close="closeModal"
      @addItem="addItem"
      v-on:updated-table="updatedList"
    />
    <update-mushroom-type
      :key="mushroomUpdateKey"
      :mushroom="selectedMushroom"
      :visible="dialogType === 'update'"
      :id="selectedMushroom.id"
      @close="closeModal"
      @updateItem="updateItem"
      v-on:updated-table="updatedList"
    />
    <delete-mushroom-type
      :visible="dialogType === 'delete'"
      :mushroom="selectedMushroom"
      :item-list="itemList"
      v-on:updated-table="updatedList"
      @close="closeDeleteModal"
    ></delete-mushroom-type>
  </div>
</template>

<script>
import CreateMushroomType from "./CreateMushroomType";
import UpdateMushroomType from "./UpdateMushroomType";
import DeleteMushroomType from "./DeleteMushroomType";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateMushroomType,
    UpdateMushroomType,
    DeleteMushroomType,
  },
  data() {
    return {
      headers: [
        { text: "Abkürzung", value: "abbreviation" },
        { text: "Latein", value: "latinName" },
        { text: "Deutsch", value: "germanName" },
        { text: "", value: "actions", sortable: false },
      ],
      itemList: [],
      mushroomUpdateKey: null,
      mushroomList: [],
      isLoading: false,
      dialogType: "",
      selectedMushroom: {},
      localSearch: null,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapGetters(["getSearchquery", "mushrooms"]),

    performSearch() {
      return this.getSearchquery;
    },
  },
  mounted() {
    this.localSearch = this.getSearchquery;
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(["fetchMushrooms", "createMushroom", "updateMushroom"]),
    editMushroom(mushroom) {
      this.selectedMushroom = { ...mushroom };
      this.dialogType = "update";
    },
    updatedList(boolean) {
      if (boolean) {
        this.fetchData();
      }
    },
    openModal(type, mushroom) {
      this.dialogType = type;
      if (type === "update") {
        this.selectedMushroom = { ...mushroom };
      }
    },
    openDeleteModal(type, mushroom) {
      this.dialogType = type;
      if (type === "delete") {
        this.selectedMushroom = { ...mushroom };
      }
    },
    closeModal() {
      this.dialogType = "";
      this.selectedMushroom = {};
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
      this.dialogType = "";
      this.selectedMushroom = {};
    },
    async addItem(newItem) {
      this.isLoading = true;
      await this.createMushroom(newItem);
      this.closeModal();
    },
    async updateItem(item) {
      this.isLoading = true;
      await this.updateMushroom(item);
      this.mushroomUpdateKey += 1;
      this.closeModal();
    },
    fetchData() {
      this.isLoading = true;
      this.fetchMushrooms()
        .then(() => {
          this.isLoading = false;
          this.$store.commit("setMushroomTypeResults", response.data);
          this.baumarts = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  handleSearch(query) {
    this.getSearchquery = query;
  },
};
</script>
<style lang="scss" scoped>
.icon-style {
  border: 1px solid #494949;
  padding: 3px;
  border-radius: 5px;
  width: 42px;
  height: 42px;
  margin-left: -60px !important;
}

.button-container {
  display: flex;
  align-items: center;
}
.button-container .delete {
  position: absolute;
  right: 15px;
}
.button-container .edit {
  position: absolute;
  right: 67px;
}
.add-button {
  outline: none !important;
  margin-bottom: 10px;
  width: 220px;
}
</style>
